module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Number-cn",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "20",
      "id": "pg_20",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 2")])])])]), _vm._v(" "), _c('h1', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAUNCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Opening-Text-No-Indent-cotx1"
  }, [_c('span', {
    attrs: {
      "aria-label": "21",
      "id": "pg_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Like any superhero in the comic books he was reading, Elon needed a plan to get the one thing he really wanted: a new address in America. But his plans never seemed to work out. Arguing, explaining, negotiating, Elon tried to convince his parents to move to America—for years. And for a while, it seemed he might catch a break. Elon’s dad had finally agreed to make America their new home. But in the end, Errol changed his mind. It was quite a blow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("While Errol may have changed "), _c('i', [_vm._v("his")]), _vm._v(" mind, Elon "), _c('i', [_vm._v("never")]), _vm._v(" wavered from that goal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Whenever I would read about cool technology, it would tend to be in the United States, or more broadly North America, including "), _c('span', {
    attrs: {
      "aria-label": "22",
      "id": "pg_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Canada. So I wanted to be where the cutting edge technology was,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-28",
      "id": "notes-ch2_28"
    }
  }, [_vm._v("28")])]), _vm._v(" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And if Elon stayed in South Africa he would be forced to participate in mandatory military service for a regime he didn’t believe in.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t have an issue with serving in the army per se, but serving in the South African army suppressing black people just didn’t seem like a really good way to spend time,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-29",
      "id": "notes-ch2_29"
    }
  }, [_vm._v("29")])]), _vm._v(" Elon explained.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But how could he just move to another country and start a new life? And specifically, how could he just move to America to live, study, and work? He was South African, not American. Immigration laws didn’t allow you to just show up and put down stakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Thinking it over, Elon’s attention turned to his mother. Though she moved to South Africa at a young age, she was actually Canadian. And her father was American! Could Elon get citizenship through his grandfather? That hope was quickly dashed because his mother did not hold an American passport.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Researching immigration law, Elon kept looking for a solution. Perhaps he couldn’t move directly to America, but what about Canada? Elon reasoned that if he received a Canadian passport, it would be easier to "), _c('i', [_vm._v("eventually")]), _vm._v(" immigrate to the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Digging around in the details of citizenship law, seventeen-year- old Elon found a way out of South Africa. Because his mother was born in Canada, her children were eligible for Canadian citizenship. All he needed her to do was fill out the paperwork to get her Canadian passport, and then he could get one too. Elon filled out the forms and immediately put them in the mail. After nearly a year, Elon’s passport finally arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Within three weeks of getting my Canadian passport, I was in Canada.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-30",
      "id": "notes-ch2_30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "23",
      "id": "pg_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("This was no small thing. In 1989, when Elon made this trip, there was no Internet, really. You couldn’t google your destination. Google Maps would not be there to help you get from point A to point B. In fact, if you wanted to travel, you usually turned to a professional travel agent. But Elon did not have that resource. His father wasn’t funding this adventure; he’d only pay for schooling in South Africa. If Elon was going to make it in Canada, he had to figure it out himself: what to do, where to settle, and how to pay for it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sealing an envelope, Maye sent a letter to her uncle in Montreal announcing Elon’s arrival. It would be great if Elon could stay with him. She waited for a reply, but by the time Elon’s flight took off for Canada, she had not heard back.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon’s plane landed and he needed to get ahold of this long-lost uncle. Plunking coins into the slot of pay phone, Elon did what everyone did back then to find a phone number: he called the operator. But the operator could not find a listing for Elon’s uncle.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("THROWBACK!")]), _vm._v(" Before cell phones, if you needed to make a call away from home or work or school, you had to use a public pay phone. They were conveniently placed in airports, hotels, some street corners, and other busy places. You held the receiver up to your ear and started putting coins into it—like a parking meter. The more money you spent the longer you could talk. Mid-conversation, the phone would alert you that your time was running out, which resulted in a sort of dance—people urgently searching pant pockets, purses, and wallets for extra coins! But there was a backup if you wanted to save your money: calling “collect.” The operator would place the call and ask the person on the other end to pay for it. If you were calling your parents, this was definitely the way to go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "24",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Elon called his mom back in South Africa.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Collect call from Elon Musk. Will you pay for the call?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon’s mother took the call. And that’s when she gave Elon the news. The uncle, Elon’s would-be Canadian host, had moved to Minnesota. "), _c('i', [_vm._v("Minnesota")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Now what? Elon had a backpack, a suitcase full of books, and two thousand bucks. It wouldn’t go far.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon found a youth hostel in Montreal and paid for the cheapest bed he could find.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But he needed a plan and fast. He was halfway around the world, with little money, no family, and no idea what he was going to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "Head-Level-1-h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "25",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_sub4",
      "id": "sub4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("YOU, TOO, CAN BE ELON MUSK FOR JUST $1 A DAY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Main-Text-1st-Line"
  }, [_vm._v("Walking around Montreal, Elon started to come up with ideas. He knew that other distant relatives (whom he’d never met before) lived in Canada, but nowhere near Montreal. In fact, they lived in the province of Saskatchewan.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_vm._v("Saskatchewan was home to a large community of South Africans who fled apartheid in political protest and in hopes of greater economic opportunities that were simply not possible in South Africa at that time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Of all the options he considered, the cheapest was to buy a countrywide bus ticket and try to find his family.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nearly two thousand miles later, Elon crossed into Saskatchewan and stepped off the bus in a tiny town called Swift Current. Once again, Elon found himself again pushing coins into a pay phone.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He dialed the number of a second cousin. No one knew Elon was coming. No one would recognize his voice. But as Elon waited for someone to answer the phone, he hoped that being family would be enough to land him a place to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He was in luck. This time, his cousin answered the phone. Hitching a ride, Elon soon showed up on the front doorstep and was shown a guest bed.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "images/pg26.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "Image-Credit"
  }, [_c('i', [_vm._v("Elon Musk’s tweet about his time in Saskatchewan (screenshot taken March 8, 2019).")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Now, he could check shelter off the list. Next, he needed money. He’d landed on Canadian soil with around two thousand bucks. Some was spent on hostels. Some was spent on his bus ticket. Some was spent on food. It was not going to take him much farther.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("So he would need to find a job to make money to feed himself and save for some kind of future, which would require an education.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Thinking it through, Elon wondered what was the least amount of money he needed to survive. Researching the cost of food, he figured he could get that cost down to a dollar a day, by purchasing hot dogs and oranges in bulk. Hot dogs and oranges. Yum.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“You can really get tired of hot dogs and oranges after a while,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-31",
      "id": "notes-ch2_31"
    }
  }, [_vm._v("31")])]), _vm._v(" Elon later joked in an interview with Neil deGrasse Tyson. Occasionally he threw in some pasta, a green pepper, and even a giant jar of tomato sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So if I could live for a dollar a day,” he explained, “well, it’s pretty easy to earn like thirty dollars in a month.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-32",
      "id": "notes-ch2_32"
    }
  }, [_vm._v("32")])]), _vm._v(" Elon started knocking on doors looking for work. He tried farm work, growing vegetables and shoveling grain. He went to Vancouver, British Columbia, and wielded a chain saw as he tried logging. The most profitable post in this series of odd jobs was cleaning the boiler room of a lumber mill. But it was the stuff of nightmares.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Pulling on his hazmat suit, Elon crawled and wiggled his way through a tight underground tunnel to access the boiler.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Then, you have to shovel and you take the sand and goop and other residue, which is still steaming hot, and you have to shovel it through the same hole you came through. There is no escape. Someone else on the other side has to shovel it into a wheelbarrow,” Elon explained. “If you stay in there for more than thirty minutes, you get too hot and die.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-33",
      "id": "notes-ch2_33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("On the upside, he made eighteen bucks an hour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Once Elon had a little bit of money, he enrolled in college.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Soon, his mother came for a visit. In addition to seeing her eldest boy, Maye was on a mission of her own—scoping out Canada and making a plan to move there.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Back in South Africa, Elon’s fifteen-year-old sister, Tosca, was also getting down to business. While her mother was out of town, Tosca put the family home on the market—and sold it. Then she sold the furniture and her mother’s car. When Maye returned to South Africa, Tosca asked her mother to sign on the dotted line to close the deal.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Queen’s University. Kingston, Ontario. Founded in 1841. The school’s motto is "), _c('i', [_vm._v("Sapientia et Doctrina Stabilitas,")]), _vm._v(" “Wisdom and knowledge shall be the stability of thy times.”")])])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/pg28.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "Image-Credit"
  }, [_c('i', [_vm._v("Ontario Hall at Queen’s University. (Photo by Shin.)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As Elon’s classes began at Queen’s University in Ontario, his mother and sister rented a small apartment less than three hours away in Toronto. As for Kimbal, he had a year of high school left and stayed in South Africa to finish. But make no mistake about it: As soon as his studies wrapped up, Kimbal intended to move to Canada as well.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon quickly settled into life on a college campus. Spending time talking about things like electric cars or space or any other intellectual topic he wanted to delve into, he felt comfortable. And he was meeting other students who didn’t mind his know-it-all fact machine conversation style. His knowledge and drive was less out of place. It wasn’t that he became the popular man about campus. But he found a place for himself and friends to share the journey. Elon bonded "), _c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("with his dormmate, Navaid Farooq, who also grew up abroad and had an interest in strategy games. Controllers in hand, they spent hours gaming together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("For extra cash, Elon built a little makeshift business selling computers and their parts. Tweaking this and that, he offered customized service. “I could build something to suit their needs like a tricked-out gaming machine or a simple word processor that cost less than what they could get in a store,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-34",
      "id": "notes-ch2_34"
    }
  }, [_vm._v("34")])]), _vm._v(" he explained to a reporter. And if people ran into problems with any computer, he could always fix it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Something else soon caught his attention: dating. In his second year Elon was captivated by a beautiful new student, Justine Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She was also smart and this intellectual with sort of an edge. She had a black belt in tae kwon do and was semi-bohemian and, you know, like the hot chick on campus,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-35",
      "id": "notes-ch2_35"
    }
  }, [_vm._v("35")])]), _vm._v(" he told biographer Ashlee Vance.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He had to figure out how to meet her. And Elon being Elon, he quickly came up with a plan.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Waiting outside her dorm, he “accidentally” bumped into her. He attempted small talk and even got her to agree to meet up for an ice cream.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Only, she didn’t show. She was too busy studying. So he found out through friends what flavor ice cream she liked best, and then he delivered it to her as she sat behind a pile of books in the student center. And he did not stop there. He sent roses, books (since she wanted to be a writer). Justine was swept off her feet, and the two started dating.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("By now, Kimbal had made his way to Canada and also enrolled in Queen’s. Reunited, the Musk brothers were ready to take on the world. They figured if you want to be big in business, you better learn from the people already running big companies. And so they started "), _c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("by making a list of important people. Scouring the newspaper, they jotted down the names of business leaders and decision makers. And then they started cold-calling each and every one to try to set up a lunch, a dinner, a coffee, any face-to-face meeting where they could pick an expert’s brain and learn something you couldn’t get sitting in a lecture hall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They called sports team owners, business reporters, CEOs, and a lot of bank executives. And one of them, Peter Nicholson, from Scotiabank, thought the Musk brothers’ curiosity, drive, and pluck were absolutely fantastic.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I was perfectly prepared to have lunch with a couple of kids that had that kind of gumption,” Nicholson reminisced to a reporter."), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-36",
      "id": "notes-ch2_36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Thrilled, Elon and Kimbal took a three-hour train ride to pick Nicholson’s brain. The executive was so impressed that he offered Elon a summer internship.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That summer, as Elon not only toiled away at his intern-level responsibilities, he also soaked in every detail of banking that he could. And that information didn’t sit idle in his head. Elon analyzed it and summed up the entire banking industry with fresh eyes. To Elon, banks were neither nimble nor innovative. And, in his opinion, their lack of fresh, original thinking in their business was actually costing them money in missed opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“All the banks did was copy what everyone else did. If everyone else ran off a bloody cliff, they’d run right off a cliff with them. If there was a giant pile of gold sitting in the middle of the room and nobody was picking it up, they wouldn’t pick it up either,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-37",
      "id": "notes-ch2_37"
    }
  }, [_vm._v("37")])]), _vm._v(" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon also learned the more pedestrian lesson of working in a real office: If an office coffee maker is labeled "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXECUTIVES ONLY")]), _vm._v(", an intern—no matter how self-assured or brilliant he might be and no "), _c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("matter how dumb the existence of an exclusive pot of coffee may seem—should not use it. Ever. Not unless that intern wants to be yelled at—the way Elon was for sipping coffee from said pot o’ java.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As summer came to an end, Elon was readying for big changes. With two years of stellar coursework under his belt, Elon had applied to the University of Pennsylvania. Not only was he accepted, he received a scholarship and transferred in 1992.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_vm._v("The University of Pennsylvania, aka Penn, is an Ivy League school in Philadelphia. Opening its doors in 1751, the school followed the educational principles of it first president, Benjamin Franklin, one of Elon’s heroes. Wharton is the university’s business school.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/pg31.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "Image-Credit"
  }, [_c('i', [_vm._v("Jon M. Huntsman Hall, the main building of the Wharton School at the University of Pennsylvania. (Photo by WestCoastivieS.)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It meant leaving his mom, brother, and sister in Canada. It also meant a long-distance relationship with his girlfriend, Justine. But it also meant he had finally made it to America.")])]), _vm._v(" "), _c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "Head-Level-1-h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_sub5",
      "id": "sub5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("AMERICA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Main-Text-1st-Line"
  }, [_vm._v("New digs, new problems. Elon needed to find a way to support himself in his new country. Even with a scholarship, Elon still had expenses.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He turned to his new roommate, Adeo Ressi, and they began to scheme.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_vm._v("A New York City kid, Adeo Ressi returned to his hometown in 1994 and created an online guide to the city that was snapped up by America Online. Ressi continued founding successful companies and served on the board of the XPRIZE Foundation. Today he is the CEO of the Founder Institute, which trains future entrepreneurs.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/pg32.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "Image-Credit"
  }, [_c('i', [_vm._v("Adeo Ressi speaking at the Start-up Festival 2014. (Photo by Eva Blue.)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Steps"
  }, [_c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("STEP ONE: Rent a huge house. (They found a ten-bedroom house to suit their needs and got a deal on the rent.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Steps"
  }, [_vm._v("STEP TWO: Live in it during the week.")]), _vm._v(" "), _c('p', {
    staticClass: "Steps"
  }, [_vm._v("STEP THREE: Turn said house into a nightclub on the weekends.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That’s right, a nightclub.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Garbage bags darkened the windows, glow-in-the-dark paint lit up the walls, and the bass thumped hard enough to shake the ground outside. And the price to get in? Five dollars a person, which covered drinks. They had enough beer and Jell-O shots on hand to serve the more than five hundred people who showed up.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But make no mistake, this wasn’t Elon wanting to party. This was business. “Somebody had to stay sober during these parties. I was paying my own way through college and could make an entire month’s rent in one night,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-38",
      "id": "notes-ch2_38"
    }
  }, [_vm._v("38")])]), _vm._v(" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And if Maye happened to be in town visiting her son, Elon gave her a shoebox, a place to sit at the front door, and a job: Collect the money.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon was hitting his stride. His entrepreneurial spirit thrived, and so too did his studies.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He pursued two degrees—one in economics from the Wharton School and the other in physics, turning in papers about solar energy, digitizing books, and new breakthroughs in energy storage. These were very forward-thinking ideas that he wanted to develop and explore. In the 1990s solar energy was not at the top of the average person’s mind. The world was still fixated on oil, and climate change wasn’t a topic of dinner conversation in most homes. Google—who eventually started a massive book digitization project—would not even be a company for four more years.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And yet, Elon had delved into these topics with an ability not only to understand them, but to turn them into business plans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("As Elon started thinking about what he would do after college, where he wanted to make a difference, these ideas were very much on his mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I thought about what were the areas that would most affect the future of humanity, in my opinion. The three areas were the Internet, sustainable energy, and space exploration.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-39",
      "id": "notes-ch2_39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But, in theory, you can’t work on all those things at the "), _c('i', [_vm._v("same")]), _vm._v(" time, right? So, Elon picked one: sustainable energy. And he narrowed that down to electric cars. He focused on battery storage for electric vehicles. After all, if electric cars were going to travel greater distances … like, say, to the next town, or have enough juice for an entire day of errands, the batteries needed to improve.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His attention turned to capacitors, which were more powerful, to be sure, but couldn’t store more energy—unless there was a technological breakthrough. In that case, capacitors could get really interesting! And Elon saw the potential for just such a breakthrough.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("WARNING!")]), _vm._v(" If you are planning to ask Elon about capacitors, be prepared. He can go on about them at the drop of a hat, with an absurd level of technical detail and something else—sheer delight. “So the area that I was studying was advanced capacitors—so essentially capacitors that have an energy density exceeding that of batteries. Because they have a very high power density but a low energy density,” he said in an interview, with no notes. “So obviously if you could make a capacitor that had anywhere near the energy density of a battery with this incredibly high power density and its quasi-infinite cycle and calendar life, then you’d have an awesome solution for energy storage and mobile applications.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-40",
      "id": "notes-ch2_40"
    }
  }, [_vm._v("40")])]), _vm._v(" Now, try to say that three times fast! "), _c('img', {
    staticClass: "epub",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/astonished-face_1f632.jpg",
      "width": "12"
    }
  }), _c('img', {
    staticClass: "mobi",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/astonished-face_1f632.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Even so, that breakthrough was a major "), _c('i', [_vm._v("if")]), _vm._v(" and the path to success was not guaranteed. And Elon wasn’t sure success was even a possibility. As he said years later in an interview, when you embark on something, “it’s desirable to figure out if success is at least one of the possibilities. Because for sure failure is one of the possibilities.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-41",
      "id": "notes-ch2_41"
    }
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He wanted to get this right. It was his future—requiring him to invest loads of precious time. Years could go by. And if you picked the wrong thing, well, you didn’t get that time back.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He thought the idea and research would probably make a great topic for a dissertation, but what good would that do in the end? “So you add some leaves to the tree of knowledge,” he said, laughing, “and the leaf is ‘Nope, it’s not possible.’”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-42",
      "id": "notes-ch2_42"
    }
  }, [_vm._v("42")])]), _vm._v(" That would be a bummer. And Elon’s drive centered on making a meaningful contribution to humanity. It was a lot to think about. And he needed more information.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Luckily, as his final college summer arrived in 1994, he had two internships set up in Silicon Valley—a massive dose of real world experience. Working every waking hour, Elon spent his days focusing on ultracapacitors for electric cars at a company called Pinnacle Research Institute. Then, at the end of that shift, he headed to his job at the video game maker Rocket Science!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("At the end of the summer, it was time to have a long conversation about what he learned, what he experienced, and what he wanted to do next. And there is no better format for that conversation than a good, old-fashioned road trip—with Kimbal. The two brothers bought a beater. To be fair, it was a BMW—but it was also twenty years old and not in awesome shape. But it would do.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We went on a road trip from Silicon Valley to Philadelphia,” Kimbal recounted. Laughing, he added, “I am younger than Elon, but we were both finishing school at the same time—because I am much "), _c('span', {
    attrs: {
      "aria-label": "36",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("smarter than him!”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-43",
      "id": "notes-ch2_43"
    }
  }, [_vm._v("43")])]), _vm._v(" Kimbal added that, in truth, it was Elon’s "), _c('i', [_vm._v("double")]), _vm._v(" major that accounted for their arriving at the finish line around the same time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon wasn’t the only one who needed a post-college plan; so did Kimbal. Perhaps there was something they could do together. Their conversation quickly focused on an emerging technology—the Internet. In the early 1990s the Internet was new, ripe for opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Most Americans didn’t even know what it was, much less what to use it for. Life was paper based.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“If you wanted to have access to a lot of information, like, you’d go to the Library of Congress,” Elon explained. “Unless you were physically where the books were, you did not have access to that information.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-44",
      "id": "notes-ch2_44"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When you needed money, you drove to the bank or to an ATM and withdrew it. If you needed a phone number, you turned to a paper phone book and looked it up. If you wanted to watch a movie, you went to the theater and bought a ticket. If you needed new clothes, you drove to a store and purchased them. Life was mostly conducted in person. You did business with people and places you trusted or who had a solid reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("No one had any idea how dramatically the Internet would change all that.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Elon and Kimbal spent much of that cross-country drive talking about ideas, potential Internet-based businesses. The brainstorming did not stop with the road trip, nor after Kimbal headed back to Queen’s, but continued the rest of the year.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And the more Elon thought about the Internet and all its possibilities, the more he did not want to miss out on the explosion of its development.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "37",
      "id": "pg_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("But Elon had been accepted into Stanford University’s PhD program. That would mean a doctorate in materials science engineering from the mecca of technology’s movers and shakers. If you were going to become a dot-com billionaire, this was the time and that was the place. The 1990s at Stanford, in the heart of Silicon Valley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The Internet came along, and it was like, oh, okay, the Internet. I’m pretty sure success is one of the possible outcomes. So I can either do a PhD and "), _c('i', [_vm._v("watch")]), _vm._v(" it happen or I can participate and help "), _c('i', [_vm._v("build")]), _vm._v(" it in some fashion,”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-45",
      "id": "notes-ch2_45"
    }
  }, [_vm._v("45")])]), _vm._v(" Elon explained.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_vm._v("Stanford University is located thirty-five miles south of San Francisco, in the heart of Silicon Valley. The school is known for being an incubator of tech companies. Yahoo!, Google, Cisco, Hewlett-Packard, and many more have started in the halls and dorms of Stanford. (Or nearby garage apartments!)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In 1995, Elon finished his undergrad at Penn and headed to Stanford. And on day "), _c('i', [_vm._v("two")]), _vm._v(" of his graduate education, Elon made up his mind. He did not want to stand on the sidelines as a witness. He wanted to be part of it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And so right then and there, he left. On. Day. Two.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It was a gutsy move. Quit school for a start-up. And not only that, a start-up based on technology most people did not even understand. Even though Elon had some scholarships and held raves to cover living expenses in school, he still had managed to amass $110,000 in college debt.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The safe bet would have been a Stanford degree.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But Elon did not want to simply "), _c('i', [_vm._v("observe")]), _vm._v(" one of the most exciting technological advancements. He was willing to take a huge risk and shoot for the moon.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "Sidebar-Text-No-Indent-sbtx1-Single"
  }, [_c('span', {
    attrs: {
      "aria-label": "38",
      "id": "pg_38",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("BOOKSHELF!")]), _vm._v(" "), _c('i', [_vm._v("The Lord of the Rings")]), _vm._v(" by J. R. R. Tolkien. Elon’s vision of the future and his role in it was heavily influenced by what he read. This fantasy saga was one of Elon’s favorites growing up. Like so many of the storylines that inspired Elon, this book series features an epic battle, fought by a band of heroes, who are fighting against all odds to save the world. First published in 1954–55 in three volumes, the saga became one of the best-selling novels of all time and remains popular today.")])])]), _vm._v(" "), _c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Insert-Headingc"
  }, [_c('span', {
    attrs: {
      "aria-label": "39",
      "id": "pg_39",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "id": "sub6"
    }
  }, [_vm._v("Meet the Musks")])])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "images/pg39.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "Image-Credit"
  }, [_c('i', [_vm._v("Tosca Musk. (Photo by Bloomberg/Contributor/Getty Images.)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Insert-Body"
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("NAME:")]), _vm._v(" Tosca Musk, Elon’s sister")]), _vm._v(" "), _c('p', {
    staticClass: "Insert-Body"
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("YEAR OF BIRTH:")]), _vm._v(" 1974")]), _vm._v(" "), _c('p', {
    staticClass: "Insert-Body"
  }, [_c('span', {
    staticClass: "Isotope_B"
  }, [_vm._v("PLACE:")]), _vm._v(" Pretoria, South Africa")]), _vm._v(" "), _c('p', {
    staticClass: "Insert-Body"
  }, [_vm._v("The baby of the Musk clan, Tosca also has her family’s trademark entrepreneurial spirit and talent. She is a successful film director and producer and has launched a subscription movie company called Passionflix, which streams original movies and other content adapted from romance novels. Tosca has twin children at home in Los Angeles and was inspired by her mother, Maye, who worked from home when all three kids were small. Her mother taught her the value of hard work and gave her a front-row seat to running a business.")]), _vm._v(" "), _c('p', {
    staticClass: "Insert-Body"
  }, [_vm._v("What does Tosca think of her eldest brother? “Elon has already gone to the future and come back to tell us what he’s found.”"), _c('sup', {
    attrs: {
      "epub:type": "noteref",
      "role": "doc-noteref"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/notesch1#notes-ch2-46",
      "id": "notes-ch2_46"
    }
  }, [_vm._v("46")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747e2e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 72
// module chunks = 0